import React from 'react';
import { MessageInfo } from '@/api/types';
import MediaPreview from './MediaPreview';

interface ImageMessageProps {
  message: MessageInfo;
  isOwnMessage: boolean;
}

/**
 * 图片消息组件
 */
const ImageMessage: React.FC<ImageMessageProps> = ({ message, isOwnMessage }) => {
  const attachment = message.decryptedContentData?.attachment;
  
  if (!attachment?.fileId) {
    return (
      <div className={`px-4 py-2 rounded-2xl ${
        isOwnMessage 
          ? 'bg-red-500 text-white rounded-br-md' 
          : 'bg-red-100 text-red-900 rounded-bl-md'
      }`}>
        <p className="text-sm">图片加载失败</p>
      </div>
    );
  }

  return (
    <div className={`rounded-2xl overflow-hidden ${
      isOwnMessage ? 'rounded-br-md' : 'rounded-bl-md'
    }`}>
      <MediaPreview
        fileId={attachment.fileId}
        fileName={attachment.fileName}
        fileSize={attachment.fileSize}
        mediaType="image"
        className="max-w-xs md:max-w-md"
      />
    </div>
  );
};

export default ImageMessage;
